import "../../chunk-D57E6H3M.mjs";

// src/domain/chat/constants.ts
var MAX_MESSAGE_LENGTH = 2e3;
var MAX_MESSAGES_COUNT = 100;
var MAX_CHAT_PRODUCTS = 5;
var CHAT_QUOTA_EXHAUSTED_CODE = "chat_quota_exhausted";
var PRODUCT_MENTION_LABEL = String.raw`(?:[^[\]\n]|(?<!@)\[[^[\]\n]*\])+|(?:(?!@\[)[^\]\n])+`;
function parseMentionNames(message) {
  return [...message.matchAll(new RegExp(String.raw`@\[(${PRODUCT_MENTION_LABEL})\]`, "g"))].map((match) => match[1]);
}
function getDistinctProductCount(message, currentProductId) {
  const ids = /* @__PURE__ */ new Set();
  if (currentProductId != null && currentProductId !== "") {
    ids.add(String(currentProductId));
  }
  parseMentionNames(message).forEach((id) => ids.add(id));
  return ids.size;
}
var MESSAGE_FEEDBACK_REASONS = ["incorrect_info", "not_helpful", "other"];
function isMessageFeedbackReason(value) {
  return MESSAGE_FEEDBACK_REASONS.includes(value);
}
export {
  CHAT_QUOTA_EXHAUSTED_CODE,
  MAX_CHAT_PRODUCTS,
  MAX_MESSAGES_COUNT,
  MAX_MESSAGE_LENGTH,
  MESSAGE_FEEDBACK_REASONS,
  PRODUCT_MENTION_LABEL,
  getDistinctProductCount,
  isMessageFeedbackReason,
  parseMentionNames
};
//# sourceMappingURL=constants.mjs.map